<script lang="ts">
	import { editable } from '../editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: ISbStoryData['content'][];
			label: string;
			subheadline: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="">
	{#if content.asset?.length > 0}
		<div class="relative aspect-[33/40] overflow-hidden rounded-xl lg:aspect-video">
			<Blok content={content.asset[0]} />
			<p
				class="absolute left-1/2 top-10 -translate-x-1/2 rounded-3xl bg-black/40 px-4 py-3 text-[14px]/[160%] text-white backdrop-blur-xl"
			>
				{content.label}
			</p>
		</div>
	{/if}

	<div class="mx-auto mt-4 max-w-[695px] text-balance text-center lg:mt-6">
		<SbRichtext text={content.subheadline} />
	</div>
</div>
